// extracted by mini-css-extract-plugin
export default {"Root":"adminslides_Root__g+y+t","Container":"adminslides_Container__TtRrp","slide":"adminslides_slide__Us0-W","active":"adminslides_active__SJk9y"};